import { PropertyAutoComplete } from './../autocomplete/property.autocomplete.model';
import { BaseModel } from "../base-model";
import { ItemStateModel } from "../base-itemstate";
import {
  ReportTemplateLookupInfoDto,
  ReportDocumentModelDto,
  ReportTemplateFolderLookupInfoDto
} from ".";
import { DemandAutoComplete, PersonAutoComplete } from '../autocomplete';

export interface IReportPrintTemplateModel extends ItemStateModel {
  Module?: string;
  LangId?: Number;
  TemplateId?: number;
  TemplateName?: string;
  Ids?: number[];
  ReportTitle?: string;
  IsNewWay?: boolean;
  IsAddDocument?: boolean;
  DocumentName?: string;
    DocumentTypeId?: number;
    ConfirmationAction?: number;
    PreviousPrintMessageResponse?: any;
}

export class ReportPrintTemplateModel
  extends BaseModel<IReportPrintTemplateModel>
  implements IReportPrintTemplateModel {
  ReportTitle: string;
  Module: string;
  LangId: Number;
  TemplateId: number;
  TemplateName: string;
  Ids: number[];
  IsNewWay?: boolean = true;
  IsAddDocument?: boolean = true;
  DocumentName?: string;
    ReportType?: number;
    ConfirmationAction?: number;
    PreviousPrintMessageResponse?: any;
    StartDate?: string;
    EndDate?: string;

  constructor(option?: IReportPrintTemplateModel) {
    super(option);
    
    this.Module = this.Module||null;
    this.LangId = this.LangId||null;
    this.TemplateId = this.TemplateId||null;
    this.TemplateName = this.TemplateName||null;
    this.Ids = this.Ids||[];
    this.ReportTitle = this.ReportTitle|| null;
    this.IsAddDocument = this.IsAddDocument || false;
    this.DocumentName = this.DocumentName || null;
    this.IsNewWay = true;
      this.ReportType = this.ReportType || null;
      this.ConfirmationAction = this.ConfirmationAction || 0;
      this.PreviousPrintMessageResponse = this.PreviousPrintMessageResponse || null;
      this.StartDate = this.StartDate || null;
      this.EndDate = this.EndDate || null;
  }
}

export class ReportPrintTemplateLookupModel {
  Templates: ReportPrintTemplateTemplatesLookupModel;
  Documents: ReportDocumentModelDto[];
  Properties: PropertyAutoComplete[];
  Projects: PropertyAutoComplete[];
  Demands: DemandAutoComplete[];
  Persons: PersonAutoComplete[];
  constructor() {
    this.Documents = [];
    this.Templates = new ReportPrintTemplateTemplatesLookupModel();
    this.Properties = [];
    this.Demands = [];
    this.Persons = [];
    this.Projects = [];
  }
}

export class ReportPrintTemplateTemplatesLookupModel {
  Templates: ReportTemplateLookupInfoDto[];
  Folders: ReportTemplateFolderLookupInfoDto[];
  
  constructor() {
    this.Folders = [];
    this.Templates = [];
  }
}

export class ReportPrintTemplateUpdateModel {
  Id: number;
  Field: string;
  Value: any;
}



export class PrintTemplatesStatusResultDto {
  Code: number
  Message: string
  TemplateUrl: string
}

export interface SetPrintTemplateModalVisibleParamModel {
  visible: boolean;
  props?: any;
}
